<div class="modal-overlay">
  <div class="modal-content">
    <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeModal()">&times;</button>

    <div class="modal-header">
      <h2>{{ mode === 'edit' ? ('payment.modalEditTitle' | t:'Edit Payment') : ('payment.modalNewTitle' | t:'Make Payment') }}</h2>
    </div>

    <form class="payment-form" (ngSubmit)="submitForm()">
      <div class="form-row three-col">
        <div [class.readonly-field]="isPrefillLocked">
          <app-common-dropdown
            [dropdownObj]="houseDropdownObj"
            [value]="payment.houseId"
            (valueChange)="onHouseChange($event)"
          ></app-common-dropdown>
        </div>

        <div [class.readonly-field]="isPrefillLocked">
          <app-common-dropdown
            [dropdownObj]="flatDropdownObj"
            [requestFilters]="flatDropdownFilters"
            [value]="payment.flatId"
            (valueChange)="onFlatChange($event)"
          ></app-common-dropdown>
        </div>

        <div class="renter-info-inline">
          <label>{{ 'payment.renter' | t:'Renter' }}</label>
          <div class="renter-value">
            <span class="renter-name">{{ selectedRenterName || ('placeholder.autoFromSelectedFlat' | t:'Auto from selected flat') }}</span>
            <button
              type="button"
              class="renter-info-btn"
              (click)="toggleRenterInfo()"
              [disabled]="!selectedRenterName"
              [attr.aria-label]="'payment.renterInfo' | t:'Renter Info'"
            >
              i
            </button>
            <div class="renter-info-popover" *ngIf="showRenterInfo && selectedRenterName">
              <div><strong>{{ 'payment.name' | t:'Name' }}:</strong> {{ selectedRenterName }}</div>
              <div *ngIf="selectedRenterInfo.mobile"><strong>{{ 'payment.mobile' | t:'Mobile' }}:</strong> {{ selectedRenterInfo.mobile }}</div>
              <div *ngIf="selectedRenterInfo.email"><strong>{{ 'payment.email' | t:'Email' }}:</strong> {{ selectedRenterInfo.email }}</div>
              <div *ngIf="selectedRenterInfo.photoIdNo"><strong>{{ 'payment.photoId' | t:'Photo ID' }}:</strong> {{ selectedRenterInfo.photoIdNo }}</div>
              <div *ngIf="selectedRenterInfo.permanentAddress"><strong>{{ 'payment.address' | t:'Address' }}:</strong> {{ selectedRenterInfo.permanentAddress }}</div>
              <div *ngIf="selectedRenterInfo.previousAddress"><strong>{{ 'payment.previousAddress' | t:'Previous' }}:</strong> {{ selectedRenterInfo.previousAddress }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row two-col" *ngIf="payment.flatId">
        <div [class.readonly-field]="isBillingMonthLocked()">
          <app-common-dropdown
            [compact]="true"
            [dropdownObj]="billingMonthDropdownObj"
            [value]="selectedBillingMonthValue()"
            (valueChange)="onMonthChange($event)"
          ></app-common-dropdown>
        </div>

        <div class="form-group compact">
          <label>{{ 'payment.paymentDate' | t:'Payment Date' }} *</label>
          <div class="date-input-wrap">
            <input
              type="text"
              class="date-input"
              [(ngModel)]="payment.paymentDate"
              name="paymentDate"
              [placeholder]="'placeholder.selectDate' | t:'Select date'"
              [readonly]="true"
              (click)="picker.open()"
              required
            />
            <button type="button" class="date-picker-btn" [attr.aria-label]="'placeholder.selectDate' | t:'Pick date'" (click)="picker.open()">
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1Zm13 8H4v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8ZM5 6a1 1 0 0 0-1 1v1h16V7a1 1 0 0 0-1-1H5Z"/>
              </svg>
            </button>
            <input
              matInput
              [matDatepicker]="picker"
              [value]="matDateValue"
              class="mat-date-anchor"
              (dateChange)="onDateSelected($event)"
              tabindex="-1"
              aria-hidden="true"
            />
            <mat-datepicker #picker></mat-datepicker>
          </div>
        </div>
      </div>

      <div class="form-group payment-method-group" *ngIf="payment.flatId">
        <label>{{ 'payment.paymentMethod' | t:'Payment Method' }} *</label>
        <div class="radio-group">
          <label class="radio-item">
            <input type="radio" name="paymentMethod" [value]="PaymentMethodEnum.CASH" [(ngModel)]="payment.paymentMethod" />
            <span>{{ 'paymentMethod.cash' | t:'Cash' }}</span>
          </label>
          <label class="radio-item">
            <input type="radio" name="paymentMethod" [value]="PaymentMethodEnum.BANK" [(ngModel)]="payment.paymentMethod" />
            <span>{{ 'paymentMethod.bank' | t:'Bank' }}</span>
          </label>
          <label class="radio-item">
            <input type="radio" name="paymentMethod" [value]="PaymentMethodEnum.CHEQUE" [(ngModel)]="payment.paymentMethod" />
            <span>{{ 'paymentMethod.cheque' | t:'Cheque' }}</span>
          </label>
          <label class="radio-item">
            <input type="radio" name="paymentMethod" [value]="PaymentMethodEnum.MOBILE_BANKING" [(ngModel)]="payment.paymentMethod" />
            <span>{{ 'paymentMethod.mobileBanking' | t:'Mobile Banking' }}</span>
          </label>
          <label class="radio-item" *ngIf="hasRemainingAdvance()">
            <input type="radio" name="paymentMethod" [value]="PaymentMethodEnum.ADJUST_FROM_ADVANCE" [(ngModel)]="payment.paymentMethod" />
            <span>{{ 'paymentMethod.adjustFromAdvance' | t:'Adjust From Advance' }}</span>
          </label>
          <label class="radio-item">
            <input type="radio" name="paymentMethod" [value]="PaymentMethodEnum.OTHER" [(ngModel)]="payment.paymentMethod" />
            <span>{{ 'paymentMethod.other' | t:'Other' }}</span>
          </label>
        </div>
      </div>

      <section class="amount-section" *ngIf="showBillFields">
        <h4>{{ 'payment.amountDetails' | t:'Amount Details' }}</h4>
        <div class="amount-grid">
          <div class="form-group compact">
            <label>{{ 'payment.flatRent' | t:'Flat Rent' }}</label>
            <input type="number" [(ngModel)]="payment.rentAmount" name="rentAmount" placeholder="0" />
          </div>

          <div class="form-group compact" *ngIf="billRequired.gas">
            <label>{{ 'flat.gas' | t:'Gas' }}</label>
            <input type="number" [(ngModel)]="payment.gasBillAmount" name="gasBillAmount" placeholder="0" />
          </div>

          <div class="form-group compact" *ngIf="billRequired.electric">
            <label>{{ 'flat.electric' | t:'Electric' }}</label>
            <input type="number" [(ngModel)]="payment.electricBillAmount" name="electricBillAmount" placeholder="0" />
          </div>

          <div class="form-group compact" *ngIf="billRequired.water">
            <label>{{ 'flat.water' | t:'Water' }}</label>
            <input type="number" [(ngModel)]="payment.waterBillAmount" name="waterBillAmount" placeholder="0" />
          </div>

          <div class="form-group compact" *ngIf="billRequired.service">
            <label>{{ 'flat.serviceChargeOther' | t:'Service Charge + Other' }}</label>
            <input type="number" [(ngModel)]="payment.serviceChargeAndOtherAmount" name="serviceChargeAndOtherAmount" placeholder="0" />
          </div>

          <div class="form-group compact" *ngIf="billRequired.other">
            <label>{{ (payment.negativeChargeName || '').trim() || ('flat.negativeCharge' | t:'Negative Charge') }}</label>
            <input type="number" [(ngModel)]="payment.negativeChargeAmount" name="negativeChargeAmount" [placeholder]="'flat.negativeCharge' | t:'Negative Charge'" />
          </div>

          <div class="form-group compact" *ngIf="hasRemainingAdvance() && isAdjustFromAdvanceSelected()">
            <label>{{ 'payment.adjustFromAdvance' | t:'Adjust From Advance' }}</label>
            <input type="number" [(ngModel)]="payment.advanceAdjustedAmount" name="advanceAdjustedAmount" placeholder="0" />
            <div class="field-hint">{{ 'payment.remainingAdvance' | t:'Remaining advance' }}: &#2547;{{ availableAdvanceAmount.toLocaleString('en-US') }}</div>
          </div>
        </div>
      </section>

      <div class="form-group">
        <label>{{ 'payment.remarks' | t:'Remarks' }}</label>
        <textarea
          [(ngModel)]="payment.remarks"
          name="remarks"
          rows="4"
          maxlength="100"
          [placeholder]="'payment.remarksPlaceholder' | t:'Type remarks (optional, max 100 characters)'"
        ></textarea>
      </div>

      <div class="form-feedback" *ngIf="successMessage || error">
        <div class="form-message success" *ngIf="successMessage">{{ successMessage }}</div>
        <div class="form-message error" *ngIf="error">{{ error }}</div>
      </div>

      <div class="form-actions">
        <button
          class="payment-slip-btn"
          type="button"
          (click)="downloadPaymentSlip()"
          [disabled]="isSubmitting || isLoadingPending || !canBuildPaymentSlip()"
        >
          {{ 'action.paymentSlipDownload' | t:'Payment Slip Download' }}
        </button>
        <button
          class="payment-slip-btn"
          type="button"
          (click)="printPaymentSlip()"
          [disabled]="isSubmitting || isLoadingPending || !canBuildPaymentSlip()"
        >
          {{ 'action.paymentSlipPrint' | t:'Payment Slip Print' }}
        </button>
        <button class="PositiveBTN" type="submit" [disabled]="isSubmitting || isLoadingPending">
          {{ isSubmitting ? ('common.saving' | t:'Saving...') : (mode === 'edit' ? ('payment.updateButton' | t:'Update Payment') : ('payment.addButton' | t:'Add Payment')) }}
        </button>
      </div>
    </form>
  </div>
</div>

